import ajax from "./ajax";

// export function getContentsByType(type) {
//   return ajax("/Qualification/me" + type);
// }

// export function getContentDetails(id) {
//   return ajax("/content/view/" + id);
// }

export function updateContentsById(id, data) {
  return ajax(`/FormContent/${id}`, { method: "PUT", data });
}

export function createContent(data) {
  return ajax(`/Qualification`, { method: "POST", data });
}
export function createContent2(data) {
  return ajax(`/WorkExperience`, { method: "POST", data });
}
export function getContentsByCustomerId(type, id) {
  return ajax(
    `/FormContent?ContentsSearch[type]=${type}&ContentsSearch[customer_id]=${id}`,
  );
}

export function getContentsByParam(params) {
  return ajax(`/Content/contents/?${params}`);
}

export function deleteContent(id) {
  return ajax(`/contents/${id}`, { method: "DELETE" });
}
export function getCourses() {
  return ajax(`/Qualification/courses`);
}
export function getQualifications() {
  return ajax(`/Qualification/me`);
}
export function getWorkExperience() {
  return ajax(`/WorkExperience/me`);
}


export function deleteWorkExperience(id) {
  return ajax(`/WorkExperience/${id}`, { method: "DELETE" });
}

export function deleteQualification(id) {
  return ajax(`/Qualification/${id}`, { method: "DELETE" });
}

export function updateQualification(id, data) {
  return ajax(`/Qualification/${id}`, { method: "PUT", data });
}
export function updateWorkExpierience(id, data) {
  return ajax(`/WorkExperience/${id}`, { method: "PUT", data });
}

//  Another One
// import ajax from "./ajax";

export function getContentsByType(type) {
  return ajax(
    "/Content/contents?page=1&per-page=1000&sort=display_order&ContentsSearch&Type=" +
      type,
  );
}

export function getContentDetails(id) {
  return ajax("/Content/view/" + id);
}

// export function updateContentsById(id, data) {
//   return ajax(`/contents/${id}`, { method: "PUT", data });
// }

// export function createContent(data) {
//   return ajax(`/contents`, { method: "POST", data });
// }

// export function getContentsByCustomerId(type, id) {
//   return ajax(`/contents?ContentsSearch[type]=${type}&ContentsSearch[customer_id]=${id}`);
// }

// export function getContentsByParam(params) {
//   return ajax(`/contents?${params}`)
// }

// export function deleteContent(id) {
//   return ajax(`/contents/${id}`, { method: "DELETE" });
// }
